// Accordion Group Controller
// Coordinates single-open behaviour across a stack of ui--accordion items.
//
// When `multiple` is false, opening one item closes the others. When true
// (default), items toggle independently.
//
// Listens for the `accordion:open` event that ui--accordion bubbles up:
//   <div data-controller="ui--accordion-group"
//        data-ui--accordion-group-multiple-value="false"
//        data-action="accordion:open->ui--accordion-group#onItemOpen">

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    multiple: { type: Boolean, default: true },
  }

  onItemOpen(event) {
    if (this.multipleValue) return

    // event.target is the ui--accordion element that just opened.
    const opened = event.target
    const items = this.element.querySelectorAll(
      '[data-controller~="ui--accordion"]',
    )

    items.forEach((el) => {
      if (el === opened) return

      const controller = this.application.getControllerForElementAndIdentifier(
        el,
        "ui--accordion",
      )
      if (controller) controller.close()
    })
  }
}
